import { me } from '@dto';
import { ModuleDefault } from '@modules/default';

export class Delete extends ModuleDefault {
  public deleteUserMFA (body: me.IBodyDeleteUserMFA) {
    return this.request.delete(`${this.setup.urlBase}/me/security/mfa`, body);
  }
}
